import * as React from 'react';
import { Checkbox as CheckboxBase } from "@common/components/checkbox";
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field, FieldLayout } from '../field';
import cx from 'classnames';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';

import './checkbox.styles.scss';

export type CheckboxProps = IInputComponent<boolean> & {
  labelWidth?: number;
  label: string;
  layout?: FieldLayout;
  classes?: {
    checkbox?: string
  }
};

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { className, disabled, label, labelWidth, onChange, value, metadata, description, required, margin, layout, classes } = props;

  const handleChangeWithLabel = React.useCallback(() => {
    onChange(!value);
  }, [onChange, value]);

  return (
    <Field 
      layout={layout}
      labelWidth={labelWidth} 
      label={label} 
      disabled={disabled}
      className={cx('FhqDesignToolCheckbox', className)}
      description={description}
      classes={{
        label: cx(
          'FhqDesignToolCheckbox__label', 
          layout === FieldLayout.componentThenLabel ? 'FhqDesignToolCheckbox__label--component-label' : undefined
        )
      }}
      required={required}
      margin={margin}
      inputWidth="auto"
      onLabelClick={handleChangeWithLabel}
    >
      <CheckboxBase 
        {...getTestAttributes(MODULE_NAME, metadata.description, 'checkbox')}
        checked={value} 
        className={cx('FhqDesignToolCheckbox__input', classes?.checkbox)}
        onChange={onChange}
      />
    </Field>
  );
};